<template>
  <div>
    <div
      class="stepper"
      :style="{
        backgroundColor: currentStep === steps.length - 1 ? 'var(--primary-color)' : 'grey'
      }"
    >
      <div
        v-for="(step, index) in steps"
        :key="step"
        class="step"
        :class="{active: currentStep >= index}"
        :style="{
          borderColor: index <= currentStep ? color : 'white',
        }"
        @click="$emit('stepTo', index)"
      >
        <span
          class="step-name is-size-5"
          :style="{
            position: 'relative',
            left: '12px'
          }"
        >{{ step }}</span>
      </div>
    </div>
  </div>
</template>

<script >
export default {

  name: 'CustomStepper',
  props: {
    color: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: String,
      default: '100%'
    },
    currentStep: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    linePosition () {
      if (this.currentStep >= this.steps.length) return 0
      const stepLength = Math.floor(100 / (this.steps.length - 1))
      const currentStepPosition = stepLength * this.currentStep
      return `${(currentStepPosition - 100)}%`
    }
  },
  methods: {
    next () {
      this.currentStep++
    },
    prev () {
      this.currentStep--
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/_variables.scss';
.stepper {
  display: flex;
  width: 100%;
  margin-bottom: 5px;
  overflow: hidden;
  background-color: var(--primary-color);
}

.step {
  height: 40px;
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  left: -10px;
  cursor: pointer;

  &.active {
    background-color: var(--primary-color);

    &:after {
      background-color: var(--primary-color);
    }
  }

  &:after {
    content: '';
    position: absolute;
    background: grey;
    width: 30px;
    height: 30px;
    right: -15px;
    z-index: 10;
    border-right: 1px solid white;
    border-bottom: 1px solid white;
    transform: rotate(-45deg);
  }

  .step-name {
    z-index: 20;
    user-select: none;
    color: white;
  }

  &:last-child:after {
    display: none;
  }

}
</style>
